import { reactive } from "vue";

export const useThemeStore = reactive({
  isDark: true,
  init() {
    const currentDoc = document.documentElement.getAttribute("data-theme");
    document.documentElement.setAttribute("data-theme", "dark");
  },
  toggle() {
    this.isDark = !this.isDark;
    const currentDoc = document.documentElement.getAttribute("data-theme");
    document.documentElement.setAttribute(
      "data-theme",
      this.isDark ? "dark" : ""
    );
  },
});
